module.exports = __webpack_public_path__ + "media/images/captive_portal/venue_details-ea1b72e82cfad1047818b155b14531f3.svg";